import React from 'react';
import { SdfBox, SdfQuickStat, SdfRadioButton } from '@synerg/react-components';

function StepThree({ state = {}, dispatch , control, products, setSelectedProductBtnIndex, selectedProductBtnIndex }) {
	const dtrum = global.window.dtrum;
	const { appStore } = state;

	const onCompanyChange = v => {
		const actionId = dtrum?.enterAction('product_integration '+v.name, 'button');
    	console.log('Dtrum action id on product integration selection - ', actionId);
		dispatch({ type: 'UPDATE', payload: { companySize: v.sizeName ? v.sizeName : v, useCaseID: null,
			productIntegration: v.name } });
		dtrum?.leaveAction(actionId);
	};

	// Filter out B2C Partner from the list
	const filteredProducts = products?.filter(product => 
			product.name !== 'ADP B2C Partner' && 
			product.shortName !== 'B2CPARTNER' &&
			product.id !== 'b2cpartner'
	) || [];

	return (
		<>
			<div className="mt-8">
				<span className="text-heading-05 font-bold mb-4">Product integration</span>
				<p className="text-body-02 mb-6">Select an ADP product below for which you desire to build an integration.</p>
				<span className="text-heading-05 font-bold">For which ADP product do you plan to build an integration?</span>

				<div className="mt-6 overflow-y-scroll p-1" style={{height: "24rem"}}>
					{(appStore === null || appStore === 'US') &&
						<section className="items-center justify-center h-full grid grid-cols-2 gap-4">
							{filteredProducts && filteredProducts.map((item, index) => (
								<SdfBox variant="shadowed" spacing="default" key={index}>
									<SdfQuickStat
										size="md"
										labelPosition={'bottom'}
										onClick={() => {
											onCompanyChange(item);
											setSelectedProductBtnIndex(index);
										}}>
										<div className='flex text-sm mb-2'>
											<SdfRadioButton value={item.sizeName} checked={index === selectedProductBtnIndex}/>
											<span className="text-heading-04">{item.name}</span>
										</div>
										<span className="flex left">
											{item.size && <span className="text-body-01 font-normal leading-sm">{item.description}: {item.size}</span>}
											{!item.size && <span className="text-body-01 font-normal leading-sm">{item.description}</span>}
										</span>
									</SdfQuickStat>
								</SdfBox>
							))}
						</section>}

					{appStore === 'CA' && <div id="company-CA">
						<section className="items-center justify-center h-full grid grid-cols-2 gap-4">
							<SdfBox variant="shadowed" spacing="default">
								<SdfQuickStat
									size="md"
									labelPosition={'bottom'}
									onClick={() => {
										onCompanyChange({ 
											description: "Mid-sized Business Solution",
											name: "ADP Workforce Now®",
											size: "50-999 employees",
											sizeName: "mid"
										});
										setSelectedProductBtnIndex(0);
									}}>
									<div className='flex text-sm mb-2'>
										<SdfRadioButton checked={0 === selectedProductBtnIndex}/>
										<span className="text-heading-04">ADP Workforce Now®</span>
									</div>

									<span className="flex left">
										<span className="text-body-01 font-normal leading-sm">Mid-sized Business Solution: 50-999 employees</span>
									</span>

								</SdfQuickStat>
							</SdfBox>
						</section>
					</div>}
				</div>
			</div>
		</>
	)
}

export default StepThree;
